//export type VNodeFactory = <P, O>(key: string, vnodeProps: P, htmlProps: O&Dom, children?: any[]) => VNode
export const buildClassName = (cn, co) => {
    const classes = {};
    if (cn) {
        cn.split(' ').forEach(n => {
            classes[n] = true;
        });
    }
    if (!co) {
    }
    else if (Array.isArray(co)) {
        for (let cls of co) {
            classes[cls] = true;
        }
    }
    else if (typeof co === 'string') {
        classes[co] = true;
    }
    else {
        for (let i in co) {
            if (co[i] !== undefined) {
                classes[i] = co[i];
            }
        }
        //Object.assign(classes, co)
    }
    const cn_a = [];
    for (let i in classes) {
        if (classes[i]) {
            cn_a.push(i);
        }
    }
    return cn_a.length ? cn_a.join(' ') : null;
};
